import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  HuntPackageRecord,
  ThreatProfile,
} from '@cyborg-monorepo/hunter/common';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ThreatProfileService {
  constructor(private httpClient: HttpClient) {}

  public getThreatProfilebyThreatName = (
    huntPackage: HuntPackageRecord
  ): Observable<Array<ThreatProfile>> => {
    return this.httpClient.get<Array<ThreatProfile>>(
      `${environment.api}/es/cyborg-threat-profile/query?term=${huntPackage.context.threat_names}`
    );
  };

  public getThreatProfileByUUID = (uuid: string): Observable<ThreatProfile> => {
    return this.httpClient.get<ThreatProfile>(
      `${environment.api}/es/cyborg-threat-profile/${uuid}`
    );
  };

  public getThreatProfilesbyUUIDs(
    uuids: Array<string>
  ): Observable<Array<ThreatProfile>> {
    const searchParams: { [param: string]: string | string[] } = { uuids };
    return this.httpClient.get<Array<ThreatProfile>>(
      `${environment.api}/es/cyborg-threat-profile/list/`,
      {
        params: searchParams,
      }
    );
  }
}
